module.exports = {

    // Change this to your firebase configuration! (Add Firebase to your web app)
    FIREBASE_CONFIG: {

        apiKey: "AIzaSyBY1S3Me5p63kSIQm9wuqAczl_YctCQLM4",
        authDomain: "drivers-app-production.firebaseapp.com",
        databaseURL: "https://drivers-app-production.firebaseio.com",
        projectId: "drivers-app-production",
        storageBucket: "drivers-app-production.appspot.com",
        messagingSenderId: "539758848486"

    },
    successTimeout: 5000,
    errorTimeout: 5000,
    buttonTimeout: 3000,
    fuelRecordEditTime: 60*60*1000,
};



// WEBPACK FOOTER //
// ./src/app/config.js